export interface EngineAiOutput {
  documentSummary: string
  documentType: 'proposal' | 'contract' | 'policy' | 'letter' | 'generic'
  riskCards: {
    blockId: string
    what: string
    why: string
    suggestion: string
    riskFactor: number
    issueType: string

    status: 'PENDING' | 'APPLIED' | 'DISMISSED'
    modified: 'true' | 'false' | 'added' | 'removed'
    originalText: string

    enhancedText?: string
    appliedImprovement?: string
  }[]
}

export interface VersionPartiesObject {
  // received from AI
  detectedParties?: string[]
  tier: number
  confidence: number

  // received from user
  userSelectedParty: string | null
  skippedBiasedReview: boolean

  // misc stuff
  detectionPerformed: boolean
  hasPartiesChanged: boolean
  shouldShowPartyDetectionPrompt: boolean
  executionDuration?: number
}

export enum Version {
  V0_1 = '0.1',
  V0_2 = '0.2',
  V0_3 = '0.3',
  V0_4 = '0.4',
  V0_6 = '0.6',
  V0_7 = '0.7',
  V0_8 = '0.8',
  V0_9 = '0.9',
}

export enum ModelProvider {
  OpenAI = 'openai',
  GeminiPro = 'gemini',
}

export interface ModelConfiguration {
  lightAIModel?: string
  heavyAIModel?: string
  reasoningEffort: string
  verbosity: string
}

export interface RiskResultsFilters {
  riskLevel: 'ALL' | 'HIGH' | 'MEDIUM' | 'LOW' | 'INFORMATIONAL'
  status: 'ALL' | 'PENDING' | 'APPLIED' | 'DISMISSED'
  targetBlock: string | null
}

// START: Streaming Text Action ---------------------------------------
export type StreamingTextActionDto = {
  action: 'risk_card_simplify' | 'risk_card_elaborate_more' | 'apply_improvement'
  documentVersionNumber: number
  documentPublicId: string
} & Record<string, unknown>

export enum TextAction {
  MAKE_SHORTER = 'MAKE_SHORTER',
  TONE_PROFESSIONAL = 'TONE_PROFESSIONAL',
  TONE_CASUAL = 'TONE_CASUAL',
  TONE_STRAIGHTFORWARD = 'TONE_STRAIGHTFORWARD',
  TONE_CONFIDENT = 'TONE_CONFIDENT',
  TONE_FRIENDLY = 'TONE_FRIENDLY',
  SIMPLIFY_LANGUAGE = 'SIMPLIFY_LANGUAGE',
  MAKE_LONGER = 'MAKE_LONGER',
  APPLY_IMPROVEMENTS = 'APPLY_IMPROVEMENTS',
  APPLY_ALL_IMPROVEMENTS = 'APPLY_ALL_IMPROVEMENTS',
}
